module.exports = __webpack_public_path__ + "static/media/veryvell_6.68edfc05.png";